export function isInWebView() {
  return (
    window.rmnMobileSdk?.getPlatform() === 'android' ||
    window.rmnMobileSdk?.getPlatform() === 'ios'
  );
}
